
import { defineComponent, computed,PropType,ref,watch } from 'vue'
import CardData from "@/Interfaces/user/CardData"
import { message } from 'ant-design-vue'
import cusRequest from '@/api/customer'
import sysRequest from '@/api/sys'
import store from '@/store'
// 2026-10-14：成衣封面按统一配置请求公共OSS缩略图，原图与受保护URL保持。
import {productCoverStyle,productCoverUrl} from '@/utils/productCover'
// 2026-10-15：公共缩略封面持久缓存；失败逐出坏缓存后保留原图回退。
import {useProductCoverCache} from '@/utils/productCoverCache'
export default defineComponent({
  name:"ClothCard",
  props:{
    width:{
      type:Number,
      default:230
    },
    height:{
      type:Number,
      default:400
    },
    value:{
      type:Object as PropType<CardData>,
      required:true
    }
  },
  setup(props,{emit}) {
    const coverStyle=productCoverStyle()
    // 2026-10-14：缩略失败回落一次原URL，换颜色或商品后重置，原图失败不循环重试。
    const coverFailed=ref(false)
    const coverUrl=computed(()=>coverFailed.value?(props.value.url || ''):productCoverUrl(props.value.url,400))
    watch(()=>[props.value,props.value.url],()=>{coverFailed.value=false})
    const {cachedCoverUrl,evictCover,retryCover,imageFailed,coverAttempt}=useProductCoverCache(coverUrl)
    const handleCoverError=()=>{
      evictCover()
      if(!coverFailed.value && coverUrl.value!==(props.value.url || ''))coverFailed.value=true
      else imageFailed.value=true
    }
    const retryImage=()=>{coverFailed.value=false;retryCover()}
    const showOrgProducts=()=>{ 
      sysRequest.getOrgOther(props.value.orgId).then((res)=>{
          window.open('https://'+res.data.mainPageUrl, '_blank');
        })
    }
    const previliges=computed(()=>{
      return store.getters.previliges
    })
    const vipVisibleFunctions=computed(()=>store.getters.vipVisibleFunctions || {})
    // 2026-08-31：成衣卡收藏按钮服从分店角色功能，关闭收藏列表后不再残留操作入口。
    const clientFunctionVisible=(functionName:string)=>Boolean(previliges.value[functionName] || vipVisibleFunctions.value[functionName])
    const orgId=computed(()=>{
      return store.getters.orgId
    })
    const displayDescription=computed(()=>{
      return props.value.description?props.value.description.replace(/纸样/g,''):'暂无描述'
    })
    const addFavorite=()=>{
      const params={
        orgId:store.getters.orgId,
        customerId:store.getters.userInfo.id,
        productId:props.value.id,
        productType:props.value.productType
      }
      if(!props.value.favorite || props.value.favorite==0){
        cusRequest.addFavorite(params).then(res=>{
          props.value.favorite=res.data
          message.success({content:'收藏成功！',style:{marginTop:'60px'}})
        })
      }else{
        cusRequest.delFavorite(props.value.favorite,params.productType).then(res=>{
          props.value.favorite=0
          message.success({content:'取消收藏成功！',style:{marginTop:'60px'}})
      })
      }
      
    }
    const cardClick=()=>{
      emit("cardClick",props.value)
    }
    return {
      cardClick,addFavorite,previliges,orgId,showOrgProducts,displayDescription,clientFunctionVisible,coverStyle,coverUrl,handleCoverError,cachedCoverUrl,imageFailed,retryImage,coverAttempt
    }
  }
})
